import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

@Directive({
  selector: '[hideIfNoTranslation]',
})
export class HideIfNoTranslationDirective implements AfterViewInit, OnDestroy {
  private observer: MutationObserver | undefined;

  constructor(private el: ElementRef) {
    if (typeof MutationObserver === 'undefined') {
      return;
    }
    this.observer = new MutationObserver(() => this.checkContent());
  }

  ngAfterViewInit(): void {
    this.observer?.observe(this.el.nativeElement, { childList: true, subtree: true, characterData: true });
    this.checkContent();
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  private checkContent(): void {
    const content = (this.el.nativeElement.textContent ?? '').trim();
    this.el.nativeElement.hidden = content.length === 0;
  }
}
